import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { InventoryPage } from "@/features/inventory/components/inventory-page";

// `.catch` on every key: a hand-edited or stale URL falls back to the default instead of breaking.
const search = z.object({
  tab: z.enum(["storage", "floating"]).default("storage").catch("storage"),
  grain: z.enum(["lot", "bin"]).default("lot").catch("lot"),
  stage: z.string().optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  qc: z.string().optional().catch(undefined),
  warehouse: z.number().int().positive().optional().catch(undefined),
  /** The SLOC cascade: WH → Bin → Sub Bin, the deepest one picked narrows the storage list. */
  wh: z.number().int().positive().optional().catch(undefined),
  bin: z.number().int().positive().optional().catch(undefined),
  subBin: z.number().int().positive().optional().catch(undefined),
  crop: z.number().int().positive().optional().catch(undefined),
  variety: z.number().int().positive().optional().catch(undefined),
  /** Storage as at the end of this day (YYYY-MM-DD), summed from the ledger; absent = live. */
  asOf: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/inventory/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("inventory.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <InventoryPage
      search={s}
      onSearch={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, ...next }),
          replace: true,
        })
      }
    />
  );
}
